import React from 'react'
import styles from './styles.module.css'
import Logo from "../../../assets/logos/simsim_logo_white.png";
import { generateImageAltText } from '../../../utils/contentOptimization';

function Footer() {
    return (
        <footer>
            <div className={styles.footerContainer}>
                <div className={`${styles.logo} d-flex align-items-center`}>
                    <img src={Logo} alt={generateImageAltText('footer', 'SimSim logo')} />
                    <span className={styles.footerIcon}>SimSim</span>
                </div>
                <div className={styles.email} alt="Email">
                    <p>
                        <span>Email:</span>
                        <a href="mailto:info@simsim.az">info@simsim.az</a>
                    </p>
                </div>
                <div className={styles.phone} alt="Phone">
                    <p>
                        <span>Telefon:</span>
                        <a href="tel:+994502473736">+994 50 247 37 36</a>
                    </p>
                </div>
                <div className={styles.copyright} alt="Copyright">
                    <p> &copy; {new Date().getFullYear()} Bütün hüquqlar qorunur</p>
                </div>
            </div>
        </footer>
    )
}

export default Footer